import * as React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Grid, IconButton } from '@siteground/styleguide';
import './header-back-button.css';

const HeaderBackButton = () => {
  const history = useHistory();
  const intl = useIntl();

  return (
    <Grid align="center">
      <IconButton
        color="secondary"
        icon="material/arrow_left_alt"
        aria-label={intl.formatMessage({ id: 'translate.aria-label.go.back' })}
        onClick={() => history.goBack()}
      />
    </Grid>
  );
};

export default HeaderBackButton;
